import { render, staticRenderFns } from "./ResponsavelForm.vue?vue&type=template&id=4e52ede1&"
import script from "./ResponsavelForm.vue?vue&type=script&lang=js&"
export * from "./ResponsavelForm.vue?vue&type=script&lang=js&"
import style0 from "./ResponsavelForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports